import React, { useContext, useEffect, useState } from 'react'
import globalStyles from "../../Styles/global.module.scss"
import styles from "../../Styles/ComponentStyles/MainPages/Profile.module.scss"
import memberUserStyles from "../../Styles/ComponentStyles/MainPages/Member.module.scss"

import Grid from '@mui/material/Grid2';
import { IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material';
import GlobalTextfield from '../../Utils/Layout/GlobalTextfield/GlobalTextfield';
import { MemberContext, MemberContextPayload } from '../../Context/MemberDetailsContext';
import editIcon from "../../Assets/Member/Edit-Icon.svg"
import deleteIcon from "../../Assets/Member/Delete-Icons.svg"
import { GlobalUserContext, GlobalUserContextPayload } from '../../Context/GlobalUserDetailContext';
import agent from '../../Services/api';
import { useSnackbar } from '../../Utils/Layout/GlobalSnackbar/GlobalSnackbar';
import GlobalButton from '../../Utils/Layout/GlobalButton/GlobalButton';
import { DashboardContext, DashboardDetailPayload } from '../../Context/DashboardDetailContext';
import { RemoveProfileCredPayload } from '../../models/userDetailsModel';
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import CheckIcon from '@mui/icons-material/Check';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import GlobalDialog from '../../Utils/Layout/GlobalDialog/GlobalDialog';
import GlobalWarningDialog from '../../Utils/Layout/GlobalWarningDialog/GlobalWarningDialog';

const ProfileIntegration = () => {

    const { userDetails, setUserDetails } = useContext(DashboardContext) as DashboardDetailPayload
    const { setFlagLoader, userProfileDetails, setUserProfileDetails } = useContext(GlobalUserContext) as GlobalUserContextPayload

    const { showSnackbar } = useSnackbar();
    const fetchUserId = userProfileDetails?.user?.userId

    const [isCredentialEditable, setIsCredentialEditable] = useState(false);
    const [profileUserCredentialDetails, setProfileUserCredentialDetails] = useState<any>(null)
    const [originalCredentialDetails, setOriginalCredentialDetails] = useState<any | null>(null);
    const [flagDeleteDialog, setFlagDeleteDialog] = useState<any | null>(false);
    const isChanged = (
        profileUserCredentialDetails?.username !== originalCredentialDetails?.username ||
        profileUserCredentialDetails?.password !== originalCredentialDetails?.password
    );
    const isDisabled = isCredentialEditable ? (!profileUserCredentialDetails?.username || !profileUserCredentialDetails?.password) : false;
    const userSaveValidation = !profileUserCredentialDetails?.username || !profileUserCredentialDetails?.password

    useEffect(() => {
        if (fetchUserId) {
            initializeCredentialAuth()
        }
    }, [])

    useEffect(() => {
        getUserDetails()
    }, [])

    const getUserDetails = async () => {
        try {
            setFlagLoader(true)
            const response = await agent.getUserProfileDetailsAPI.get()
            if (response?.status) {
                setUserDetails(response?.data?.user)
                setUserProfileDetails({
                    ...userProfileDetails,
                    user: {
                        ...userProfileDetails.user,
                        profileImage: response?.data?.user?.profileImage
                    }
                });
                setFlagLoader(false)
            } else {
                const err = response?.error?.message ? response?.error?.message : "Error fetching user details 1";
                showSnackbar(err, 'error')
                setFlagLoader(false)
            }
        } catch (error) {
            showSnackbar("Something Went Wrong", 'error')
        }
    }

    const initializeCredentialAuth = async () => {
        if (fetchUserId) {
            let payload = {
                userId: Number(fetchUserId)
            }

            setFlagLoader(true);
            const response = await agent.getUsersCredentialsApi.get(payload);
            if (response?.status && response?.data) {
                const userResponse = response.data?.credentials[0]
                setProfileUserCredentialDetails(userResponse);
                setOriginalCredentialDetails(userResponse);
                setFlagLoader(false);
            }
            else {
                setFlagLoader(false);
                const errorMessage = response?.error?.message || 'Something Went Wrong!';
                showSnackbar(errorMessage, 'error');
            }
        }
    };

    const handleCredentialChange = (key: string, value: string) => {
        setProfileUserCredentialDetails((prev: any) => ({
            ...prev,
            [key]: value
        }));
    };

    const handleEditClick = () => {
        setOriginalCredentialDetails({ ...profileUserCredentialDetails });
        setProfileUserCredentialDetails((prev: any) => ({
            ...prev,
            password: ''
        }));
        setIsCredentialEditable(true);
    };

    const handleRollbackClick = () => {
        if (originalCredentialDetails) {
            setProfileUserCredentialDetails({ ...originalCredentialDetails });
        }
        setIsCredentialEditable(false);
    };


    const handleUpdateCredentials = async () => {

        const payload = {
            userId: fetchUserId ?? 0,
            appName: profileUserCredentialDetails?.appName ?? "",
            username: profileUserCredentialDetails?.username ?? "",
            password: profileUserCredentialDetails?.password ?? ""
        }

        setFlagLoader(true)
        const response = await agent.changeUserCredentialsApi.post(payload)
        if (response?.status) {
            console.log("response of updateUserStatusApi", response);
            const successMessage = response?.message ? response?.message : "User credentials updated successfully!"
            showSnackbar(successMessage, "success");
            setFlagLoader(false)
            setIsCredentialEditable(false)
        }
        else {
            console.log("response false of updateUserStatusApi", response);
            setFlagLoader(false)
            const error = response?.error?.message
            if (error == "Invalid Login Attempt (Incorrect Username and/or Password)") {
                showSnackbar(
                    <div><strong>Redtail!</strong>
                        <br />
                        Invalid credentials. Account may be locked after multiple failed attempts.
                    </div>,
                    'error'
                );
            }
            else {
                showSnackbar(
                    <div><strong>Redtail!</strong>
                        <br />
                        {error}
                    </div>,
                    'error'
                );
            }
            // const successMessage = response?.error?.message ? response?.error?.message : "Something Went Wrong!"
            // showSnackbar(successMessage, "error");
            // setFlagLoader(false)
        }
    }

    const handleDeleteCred = async () => {

        const payload: RemoveProfileCredPayload = {
            userId: Number(fetchUserId),
            appName: profileUserCredentialDetails?.appName ?? ""
        }

        setFlagLoader(true)
        const response = await agent.deleteUserProfileCredentials.post(payload)
        console.log("Response log deleteUserProfileCredentials", response);
        if (response?.status) {
            const successMessage = response?.message ? response?.message : `Credential for ${profileUserCredentialDetails?.appName ?? ""} removed successfully!`
            showSnackbar(successMessage, "success");
            await initializeCredentialAuth()
            setFlagLoader(false)
            setIsCredentialEditable(false)
            setFlagDeleteDialog(false)
        }
        else {
            const successMessage = response?.error?.message ? response?.error?.message : "Something Went Wrong!"
            showSnackbar(successMessage, "error");
            setFlagLoader(false)
            setFlagDeleteDialog(false)
        }
    }

    return (
        <>
            {flagDeleteDialog &&
                <GlobalDialog
                    flagHeadSection={true}
                    open={flagDeleteDialog}
                    maxWidth="sm"
                    dialogHead={'Delete Confirmation'}
                    onClose={() => setFlagDeleteDialog(false)}
                    view={
                        <GlobalWarningDialog
                            popupDescription={`Are you sure you want to delete ${profileUserCredentialDetails?.username}?`}
                            primaryButtonText={"Delete"}
                            secondaryButtonText={"Cancel"}
                            primaryButtonWidth="175px"
                            secondaryButtonWidth="175px"
                            onDelete={handleDeleteCred}
                            handleClose={() => setFlagDeleteDialog(false)}
                        />
                    }
                />
            }

            <Grid size={{ xs: 12 }} sx={{ margin: "15px 0px 0px" }}>
                <Grid container>
                    <Grid size={{ xl: 7.5, lg: 10, md: 12, sm: 12, xs: 12 }} >
                        <TableContainer>
                            <Table size='small'>
                                <TableHead className={`${globalStyles.gblTableHeadStyles}`}>
                                    <TableRow>
                                        <TableCell
                                            className={`${globalStyles.gblTableHeadCell} ${globalStyles.gblTableMediumWidth}`}
                                            sx={{ fontSize: "14px", borderTopLeftRadius: "5px" }}
                                        >
                                            APPS
                                        </TableCell>
                                        <TableCell
                                            className={`${globalStyles.gblTableHeadCell} ${globalStyles.gblTableMediumWidth}`}
                                            sx={{ fontSize: "14px" }}
                                        >
                                            USER NAME
                                        </TableCell>
                                        <TableCell
                                            className={`${globalStyles.gblTableHeadCell} ${globalStyles.gblTableMediumWidth}`}
                                            sx={{ fontSize: "14px", }}
                                        >
                                            USER PASSWORD
                                        </TableCell>
                                        <TableCell
                                            className={`${globalStyles.gblTableHeadCell} ${globalStyles.gblTableExtraSmallWidth}`}
                                            sx={{ fontSize: "14px", borderTopRightRadius: "5px" }}
                                        >
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow className={`${globalStyles.gblTableBodyRow}`}>
                                        <TableCell className={`${globalStyles.gblTableCellText}`}>
                                            {profileUserCredentialDetails?.appName ? profileUserCredentialDetails?.appName : ""}
                                        </TableCell>

                                        <TableCell className={`${globalStyles.gblTableCellText}`}>
                                            <GlobalTextfield
                                                size='small'
                                                stylingClassName={isCredentialEditable ? memberUserStyles.credTextfield : memberUserStyles.credTextfieldDisable}
                                                autoComplete='off'
                                                value={profileUserCredentialDetails?.username || ""}
                                                onChange={(e) => handleCredentialChange("username", e.target.value)}
                                                disabled={isCredentialEditable ? false : true}
                                            />
                                        </TableCell>

                                        <TableCell className={`${globalStyles.gblTableCellText}`}>
                                            <GlobalTextfield
                                                size='small'
                                                stylingClassName={isCredentialEditable ? memberUserStyles.credTextfield : memberUserStyles.credTextfieldDisable}
                                                autoComplete='off'
                                                value={profileUserCredentialDetails?.password || ""}
                                                onChange={(e) => handleCredentialChange("password", e.target.value)}
                                                type='password'
                                                disabled={isCredentialEditable ? false : true}
                                            />
                                        </TableCell>

                                        <TableCell className={`${globalStyles.gblTableCellText}  ${globalStyles.gblTableMediumWidth}`}>
                                            <Grid container sx={{ justifyContent: "end", gap: "5px", alignItems: "center" }}>
                                                {isChanged && (
                                                    <IconButton
                                                        className={styles.rollbackCellIcon}
                                                        onClick={() => { handleRollbackClick() }}
                                                    >
                                                        <Tooltip
                                                            title="Undo"
                                                            arrow
                                                            placement="bottom"
                                                            componentsProps={{
                                                                tooltip: { className: globalStyles.globalTooltipStyle },
                                                                arrow: { className: globalStyles.globalTooltipArrowStyle },
                                                            }}
                                                        >
                                                            <SettingsBackupRestoreIcon sx={{ color: "white", fontSize: "22px" }} />
                                                        </Tooltip>
                                                    </IconButton>
                                                )}
                                                <IconButton
                                                    sx={{ p: "2px" }}
                                                    className={`${isDisabled ? globalStyles.disableBtnPointerEvent : ''}`}
                                                    onClick={isCredentialEditable ? handleUpdateCredentials : handleEditClick}
                                                    // disabled={isCredentialEditable ? (!profileUserCredentialDetails?.username || !profileUserCredentialDetails?.password) : false}
                                                    disabled={isDisabled}
                                                >
                                                    {isCredentialEditable ? (
                                                        <Tooltip
                                                            title="Save"
                                                            arrow
                                                            placement="bottom"
                                                            componentsProps={{
                                                                tooltip: { className: globalStyles.globalTooltipStyle },
                                                                arrow: { className: globalStyles.globalTooltipArrowStyle },
                                                            }}
                                                        >
                                                            <SaveIcon className={styles.rightMarkIcon} sx={{ color: "white", fontSize: "22px" }} />
                                                        </Tooltip>
                                                    ) : (
                                                        <Tooltip
                                                            title="Edit"
                                                            arrow
                                                            placement="bottom"
                                                            componentsProps={{
                                                                tooltip: { className: globalStyles.globalTooltipStyle },
                                                                arrow: { className: globalStyles.globalTooltipArrowStyle },
                                                            }}
                                                        >
                                                            <EditIcon className={styles.editMarkIcon} sx={{ color: "white", fontSize: "22px" }} />
                                                        </Tooltip>
                                                    )}
                                                </IconButton>
                                                <IconButton
                                                    sx={{ p: "2px" }}
                                                    disabled={userSaveValidation ? true : false}
                                                    className={`${userSaveValidation ? globalStyles.disableBtnPointerEvent : ''}`}
                                                    onClick={() => { setFlagDeleteDialog(true) }}
                                                >
                                                    <Tooltip
                                                        title="Delete"
                                                        arrow
                                                        placement="bottom"
                                                        componentsProps={{
                                                            tooltip: { className: globalStyles.globalTooltipStyle },
                                                            arrow: { className: globalStyles.globalTooltipArrowStyle },
                                                        }}
                                                    >
                                                        <img src={deleteIcon} style={{ width: '30px', height: "30px" }} alt="delete" />
                                                    </Tooltip>
                                                </IconButton>
                                            </Grid>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                    {/* <Grid size={{ xs: 12 }} sx={{ margin: '20px 0px' }}>
                        <Grid container sx={{ gap: "15px" }}>
                            <Grid>
                                <GlobalButton
                                    value='Cancel'
                                    size='medium'
                                    fullWidth={true}
                                    variant='outlined'
                                    className={globalStyles.globalButtonOutlinedStyleV1}
                                    onClick={() => { setIsCredentialEditable(false) }}
                                />
                            </Grid>
                            <Grid>
                                <GlobalButton
                                    value='Save'
                                    size='medium'
                                    fullWidth
                                    variant='contained'
                                    className={`${globalStyles.globleButtonStyleV1}`}
                                    disabled={!profileUserCredentialDetails?.username || !profileUserCredentialDetails?.password}
                                    onClick={handleUpdateCredentials}
                                    sx={{ background: (!profileUserCredentialDetails?.username || !profileUserCredentialDetails?.password) ? "gray !important" : "white !important" }}
                                />
                            </Grid>
                        </Grid>

                    </Grid> */}
                </Grid>
            </Grid>
        </>
    )
}

export default ProfileIntegration